import { useState } from 'react';

import { CodeInput } from '../auth/code-input.tsx';
import { Field } from '../ui/field.tsx';

/**
 * TOTP field for sensitive actions (impersonation, 2FA reset): the administrator
 * re-enters a code from their app right before acting.
 */
export function StepUpCode({ onChange }: { onChange: (code: string) => void }) {
  const [code, setCode] = useState('');
  return (
    <Field
      label="Código de tu aplicación de autenticación"
      hint="Por seguridad, confirma tu identidad con un código nuevo."
    >
      {(a11y) => (
        <CodeInput
          {...a11y}
          value={code}
          onChange={(value) => {
            setCode(value);
            onChange(value);
          }}
        />
      )}
    </Field>
  );
}
